import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';

import { tinyMCEApiKey } from '../../../config.json';
import { editorOptions } from './options';

const RichEditor = ({ initValue, ...props }) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    setContent(initValue);
  }, [initValue]);

  return (
    <Editor
      apiKey={tinyMCEApiKey}
      onInit={(evt, editor) => (editorRef.current = editor)}
      initialValue={content}
      onEditorChange={props.onChange}
      init={editorOptions}
    />
  );
};

RichEditor.propTypes = {
  initValue: PropTypes.string,
  onChange: PropTypes.func,
};

export default RichEditor;



// WEBPACK FOOTER //
// src/components/shared/RichEditor/index.jsx